import { render, staticRenderFns } from "./CustomSettings.vue?vue&type=template&id=fb36ab5c&scoped=true&"
import script from "./CustomSettings.vue?vue&type=script&lang=js&"
export * from "./CustomSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb36ab5c",
  null
  
)

export default component.exports